<template>
    <h5 class="list__address" :title="unitLmsgLocation" >{{unitLmsgLocation}}</h5>
</template>
<script>
    import unitLmsgMixin from "@/mixins/unitLmsgMixin";

    export default {
        name: 'UnitsList_unit_address',
        mixins: [unitLmsgMixin],
        props: {
            unitId: Number,
        },
        data() {
            return {}
        },
        computed: {
        },
        updated: function() {
           // console.log(`UnitsList_unit_address ${this.unitLmsgLocation} updated`);
        },
    }
</script>